import { useEffect, useState } from "react";

import { LawFirmsAPI } from "../../../api/lawFirms";
import type { ForeignNational } from "../../../api/types/foreignNational";

export type LawFirmWhitelabel = {
  lawFirmName: string | null;
  lawFirmLogoUrl: string | null;
  enableWhitelabelForeignNationalIntake: boolean;
};

/** Firm branding the Requests panel uses for client-facing intake previews. */
export const useLawFirmWhitelabel = (
  client: Pick<ForeignNational, "law_firm_id" | "practice_name"> | null
): LawFirmWhitelabel => {
  const lawFirmId = (client?.law_firm_id ?? "").trim();
  const practiceName = (client?.practice_name ?? "").toString().trim();
  const [value, setValue] = useState<LawFirmWhitelabel>({
    lawFirmName: practiceName || null,
    lawFirmLogoUrl: null,
    enableWhitelabelForeignNationalIntake: false
  });

  useEffect(() => {
    let cancelled = false;
    setValue({
      lawFirmName: practiceName || null,
      lawFirmLogoUrl: null,
      enableWhitelabelForeignNationalIntake: false
    });
    if (!lawFirmId) return undefined;

    LawFirmsAPI.getById(lawFirmId)
      .then((firm) => {
        if (cancelled) return;
        setValue({
          lawFirmName: (firm?.name ?? "").toString().trim() || null,
          lawFirmLogoUrl: (firm?.logo_url ?? "").toString().trim() || null,
          enableWhitelabelForeignNationalIntake:
            firm?.enable_whitelabel_foreign_national_intake === true
        });
      })
      .catch(() => {
        if (cancelled) return;
        setValue({
          lawFirmName: null,
          lawFirmLogoUrl: null,
          enableWhitelabelForeignNationalIntake: false
        });
      });

    return () => {
      cancelled = true;
    };
  }, [lawFirmId, practiceName]);

  return value;
};
